import Vue from 'vue'
import VueRouter from 'vue-router'

// CUSTOMER BASE
import CustomerBase from '@/views/customer_base/Main'

// PAYMENT LINKS
import PaymentLink from '../views/payment-links/Main'
import IntentRetrieve from '../views/payment-links/IntentRetrieve'
import GatewayMercadopago from '../views/payment-links/GatewayMercadopago'
import GatewayWebpay from '../views/payment-links/GatewayWebpay'

// SIGNUP FORMS
import SignupForms from '@/views/signup_forms/Main'
import SignupFormsSuccess from '@/views/signup_forms/Success'

// HTTP
import PageNotFound from '@/views/http/PageNotFound'

Vue.use(VueRouter)

const routes = [
  {
    path: '/customer_base/:pk',
    name: 'CustomerBaseAuth',
    component: CustomerBase,
    meta: {
      title: 'Customer Base Auth'
    }
  },
  {
    path: '/customer_base/:pk/:session',
    name: 'CustomerBase',
    component: CustomerBase,
    meta: {
      title: 'Customer Base'
    }
  },
  {
    path: '/payment_links/links/:pk',
    name: 'PaymentLink',
    component: PaymentLink,
    meta: {
      title: 'Link'
    }
  },
  {
    path: '/payment_links/intents',
    name: 'IntentRetrieve',
    component: IntentRetrieve,
    meta: {
      title: 'Pago'
    }
  },
  {
    path: '/payment_links/links/:id/mercadopago',
    name: 'GatewayMercadopago',
    component: GatewayMercadopago,
    meta: {
      title: 'Pago con MercadoPago'
    }
  },
  {
    path: '/payment_links/links/:id/webpay',
    name: 'GatewayWebpay',
    component: GatewayWebpay,
    meta: {
      title: 'Pago con Webpay'
    }
  },
  {
    path: '/signup_forms/:id',
    name: 'SignupForms',
    component: SignupForms,
    meta: {
      title: 'Signup Forms'
    }
  },
  {
    path: '/signup_forms/:id/success',
    name: 'SignupFormsSuccess',
    component: SignupFormsSuccess,
    meta: {
      title: 'Signup Forms'
    }
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {
      title: 'Página no encontrada'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
